import { FC, ReactNode } from 'react'

const GuestLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return <div>{children}</div>
}

export default GuestLayout
